import React, { useState } from 'react';
import { List, ListItem, ListItemText, Collapse, Tooltip } from '@mui/material';
import { PostAdd, TableView, StickyNote2Outlined, PriceCheck, ManageSearch, TurnedInNot, Tune,
  ExpandMore, ExpandLess } from '@mui/icons-material';
import CustomNavLink from '../../components/CustomNavLink';
import styles from '../css/Layout.module.css';

const CountryNavigation = ({ userGroups, isDrawerOpen }) => {
  const [openJapan, setOpenJapan] = useState(false);
  const [openKorea, setOpenKorea] = useState(false);

  const handleClickJapan = () => {
    setOpenJapan(!openJapan);
    if (openKorea) {
      setOpenKorea(false);
    }
  };

  const handleClickKorea = () => {
    setOpenKorea(!openKorea);
    if (openJapan) {
      setOpenJapan(false);
    }
  };

  // 檢查用戶是否有權限訪問日本線
  const hasJapanAccess = () => {
    return userGroups.some(group => 
      ['日本線業務', '日方人員', '管理員', '會計人員', '日本線管理'].includes(group)
    );
  };

  // 檢查用戶是否有權限訪問韓國線
  const hasKoreaAccess = () => {
    return userGroups.some(group => 
      ['韓國線業務', '韓方人員', '管理員', '會計人員', '韓國線管理'].includes(group)
    );
  };

  // 完整展開的導航列表
  if (isDrawerOpen) {
    return (
      <>
        {/* 日本線 - 只對有權限的用戶顯示 */}
        {hasJapanAccess() && (
          <>
            <ListItem className={styles['part-listitem']} button onClick={handleClickJapan}>
              <ListItemText className={styles['part-text']} disableTypography={true}>
                日本線 / Japan
              </ListItemText>
              <Tooltip title="展開 / 收起" placement="right">
                {openJapan ? <ExpandLess /> : <ExpandMore />}
              </Tooltip>
            </ListItem>
            <Collapse in={openJapan} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {(userGroups.includes('日本線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Japan/order-create" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <PostAdd className={styles.Navicon} />
                      新增訂單
                    </ListItem>
                  </CustomNavLink>
                )}
                {(userGroups.includes('日本線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Japan/order-table" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <TableView className={styles.Navicon} />
                      業務報表
                    </ListItem>
                  </CustomNavLink>
                )}
                <CustomNavLink to="/Japan/charterbooking-table" activeClassName="active">
                  <ListItem className={styles.listitem} button>
                    <StickyNote2Outlined className={styles.Navicon} />
                    訂團表
                  </ListItem>
                </CustomNavLink>
                {(userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Japan/accounting-table" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <PriceCheck className={styles.Navicon} />
                      對帳表
                    </ListItem>
                  </CustomNavLink>
                )}
                <CustomNavLink to="/Japan/contact-record" activeClassName="active">
                  <ListItem className={styles.listitem} button>
                    <ManageSearch className={styles.Navicon} />
                    聯絡記錄
                  </ListItem>
                </CustomNavLink>
                {(userGroups.includes('日本線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Japan/other-related" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <TurnedInNot className={styles.Navicon} />
                      其他相關
                    </ListItem>
                  </CustomNavLink>
                )}
                {(userGroups.includes('管理員') || userGroups.includes('日本線管理')) && (
                  <CustomNavLink to="/Japan/manage" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <Tune className={styles.Navicon} />
                      設定管理
                    </ListItem>
                  </CustomNavLink>
                )}
              </List>
            </Collapse>
          </>
        )}

        {/* 韓國線 - 只對有權限的用戶顯示 */}
        {hasKoreaAccess() && (
          <>
            <ListItem className={styles['part-listitem']} button onClick={handleClickKorea}>
              <ListItemText className={styles['part-text']} disableTypography={true}>
                韓國線 / Korea
              </ListItemText>
              <Tooltip title="展開 / 收起" placement="right">
                {openKorea ? <ExpandLess /> : <ExpandMore />}
              </Tooltip>
            </ListItem>
            <Collapse in={openKorea} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {(userGroups.includes('韓國線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Korea/order-create" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <PostAdd className={styles.Navicon} />
                      新增訂單
                    </ListItem>
                  </CustomNavLink>
                )}
                {(userGroups.includes('韓國線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Korea/order-table" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <TableView className={styles.Navicon} />
                      業務報表
                    </ListItem>
                  </CustomNavLink>
                )}
                <CustomNavLink to="/Korea/charterbooking-table" activeClassName="active">
                  <ListItem className={styles.listitem} button>
                    <StickyNote2Outlined className={styles.Navicon} />
                    訂團表
                  </ListItem>
                </CustomNavLink>
                {(userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Korea/accounting-table" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <PriceCheck className={styles.Navicon} />
                      對帳表
                    </ListItem>
                  </CustomNavLink>
                )}
                <CustomNavLink to="/Korea/contact-record" activeClassName="active">
                  <ListItem className={styles.listitem} button>
                    <ManageSearch className={styles.Navicon} />
                    聯絡記錄
                  </ListItem>
                </CustomNavLink>
                {(userGroups.includes('韓國線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                  <CustomNavLink to="/Korea/other-related" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <TurnedInNot className={styles.Navicon} />
                      其他相關
                    </ListItem>
                  </CustomNavLink>
                )}
                {(userGroups.includes('管理員') || userGroups.includes('韓國線管理')) && (
                  <CustomNavLink to="/Korea/manage" activeClassName="active">
                    <ListItem className={styles.listitem} button>
                      <Tune className={styles.Navicon} />
                      設定管理
                    </ListItem>
                  </CustomNavLink>
                )}
              </List>
            </Collapse>
          </>
        )}
      </>
    );
  }
  
  // 折疊後的導航列表
  return (
    <>
      {/* 折疊版本的日本線 - 只對有權限的用戶顯示 */}
      {hasJapanAccess() && (
        <>
          <ListItem className={styles['part-listitem']} button onClick={handleClickJapan}>
            <Tooltip title="日本線 / Japan" placement="right">
              <ListItemText className={styles['part-text']} disableTypography='true'>
                JP
              </ListItemText>
            </Tooltip>
          </ListItem>
          <Collapse in={openJapan} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(userGroups.includes('日本線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Japan/order-create" activeClassName="active-closed">
                  <Tooltip title="新增訂單" placement="right">
                    <ListItem className={styles.listitem} button>
                      <PostAdd />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              {(userGroups.includes('日本線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Japan/order-table" activeClassName="active-closed">
                  <Tooltip title="業務報表" placement="right">
                    <ListItem className={styles.listitem} button>
                      <TableView />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              <CustomNavLink to="/Japan/charterbooking-table" activeClassName="active-closed">
                <Tooltip title="訂團表" placement="right">
                  <ListItem className={styles.listitem} button>
                    <StickyNote2Outlined />
                  </ListItem>
                </Tooltip>
              </CustomNavLink>
              {(userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Japan/accounting-table" activeClassName="active-closed">
                  <Tooltip title="對帳表" placement="right">
                    <ListItem className={styles.listitem} button>
                      <PriceCheck />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              <CustomNavLink to="/Japan/contact-record" activeClassName="active-closed">
                <Tooltip title="聯絡記錄" placement="right">
                  <ListItem className={styles.listitem} button>
                    <ManageSearch />
                  </ListItem>
                </Tooltip>
              </CustomNavLink>
              {(userGroups.includes('日本線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Japan/other-related" activeClassName="active-closed">
                  <Tooltip title="其他相關" placement="right">
                    <ListItem className={styles.listitem} button>
                      <TurnedInNot />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              {(userGroups.includes('管理員') || userGroups.includes('日本線管理')) && (
                <CustomNavLink to="/Japan/manage" activeClassName="active-closed">
                  <Tooltip title="設定管理" placement="right">
                    <ListItem className={styles.listitem} button>
                      <Tune />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
            </List>
          </Collapse>
        </>
      )}

      {/* 折疊版本的韓國線 - 只對有權限的用戶顯示 */}
      {hasKoreaAccess() && (
        <>
          <ListItem className={styles['part-listitem']} button onClick={handleClickKorea}>
            <Tooltip title="韓國線 / Korea" placement="right">
              <ListItemText className={styles['part-text']} disableTypography='true'>
                KR
              </ListItemText>
            </Tooltip>
          </ListItem>
          <Collapse in={openKorea} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(userGroups.includes('韓國線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Korea/order-create" activeClassName="active-closed">
                  <Tooltip title="新增訂單" placement="right">
                    <ListItem className={styles.listitem} button>
                      <PostAdd />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              {(userGroups.includes('韓國線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Korea/order-table" activeClassName="active-closed">
                  <Tooltip title="業務報表" placement="right">
                    <ListItem className={styles.listitem} button>
                      <TableView />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              <CustomNavLink to="/Korea/charterbooking-table" activeClassName="active-closed">
                <Tooltip title="訂團表" placement="right">
                  <ListItem className={styles.listitem} button>
                    <StickyNote2Outlined />
                  </ListItem>
                </Tooltip>
              </CustomNavLink>
              {(userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Korea/accounting-table" activeClassName="active-closed">
                  <Tooltip title="對帳表" placement="right">
                    <ListItem className={styles.listitem} button>
                      <PriceCheck />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              <CustomNavLink to="/Korea/contact-record" activeClassName="active-closed">
                <Tooltip title="聯絡記錄" placement="right">
                  <ListItem className={styles.listitem} button>
                    <ManageSearch />
                  </ListItem>
                </Tooltip>
              </CustomNavLink>
              {(userGroups.includes('韓國線業務') || userGroups.includes('會計人員') || userGroups.includes('管理員')) && (
                <CustomNavLink to="/Korea/other-related" activeClassName="active-closed">
                  <Tooltip title="其他相關" placement="right">
                    <ListItem className={styles.listitem} button>
                      <TurnedInNot />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
              {(userGroups.includes('管理員') || userGroups.includes('韓國線管理')) && (
                <CustomNavLink to="/Korea/manage" activeClassName="active-closed">
                  <Tooltip title="設定管理" placement="right">
                    <ListItem className={styles.listitem} button>
                      <Tune />
                    </ListItem>
                  </Tooltip>
                </CustomNavLink>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default CountryNavigation;
